
import { action, makeAutoObservable, toJS } from "mobx";
import { UserStore } from "./user-store";
import { ApisauceInstance, create } from "apisauce";
import { ProjectStore } from "./project-store";
import { FlexiStore } from "./fs";
import { AiGentoolsStore } from "./ai-gentools-store";
import { TaskManagerStore } from "./task-manager-store";
import { ReportStore } from "./report-store";
import { safe_get } from "../report-visuals";
import { SurveyResponseStore } from "./survey-response-store";
import { VoterListStore } from "./voter-list-store";
import { BeneficiaryStore } from "./beneficiary-store";
import { VoterReachOutStore } from "./voter-reachout-store";
import { ElectionDayDashboardStore } from "./election-day-dashboard-store";
import { C3Store } from "./c3-store";
import { GrievanceStore } from "./grievance-management-store";
import { ProjectWorksStore } from "./project-works";
import { FieldIntelligenceStore } from "./field-intelligence";
import { DigitalArchiveStore } from "./digital-archive";
import { InfluentialLeadersStore } from "./influential-leaders";
import { ProjectWorkStoreV2 } from "./project-worksv2";
import { QuestionStore } from "./question-store/QuestionStore";
import { InfluenceLeaderProjectPropertyStore } from "./influence-leader-project-properties/influenceLeaderPropertyStore";
import { BeneficiaryStoreV2 } from "./beneficiary-storev2";
import { GrievanceMgmtStoreV2 } from "./grievance-store-v2";
import { ServiceRequestsStore } from "./service-requests-store";
import { SchemeStore } from "./my-scheme/schemestore";
import { RTEStore } from "./rte-store";
import { getCoordinates, getIP } from "../helpers/geolocation";
import * as DeviceUUID from "device-uuid";
import { FamilyGrpStore } from "./family-group/familygroupstore";
import { NotesStore } from "./notes-store";
import ServicePortalStore from "./service-portal-store/ServicePortalStore";
import { GovermentConfigStore } from "./Goverment-config/govtConfigStore";
import { ActiveSurveyStore } from "./active-survey-store/active-survey-store";
import { CockpitStore } from "./cockpit-store";
import { GeopolTransformerStore } from "../new-features/geopol-transformer/geopol-transformer-store";
import { PrintMediaStore } from "../new-features/print-media/print-media-store";
import { TarsStore } from "./tars/tars-store";
import { TarsAnalyticsStore } from "./tars/tars-analytics-store";
import { QFastStore } from "./qfast-store";
import { SIRStore } from "./sir-store";

const BASE_URL = "https://platform.forthepeople.ai/api/v1/";

// const BASE_URL = "http://localhost:8000/api/v1/";

const API_HEADER = "620bcdb9-4120-411c-8e15-50c0e8d55404-11eb-adc1-0242ac120002";

export class RootStore {
    appMode: Boolean;
    api: ApisauceInstance | undefined;
    userStore: UserStore;
    projectStore: ProjectStore;
    reportStore: ReportStore;
    flexiStore: FlexiStore;
    surveyResponseStore: SurveyResponseStore;
    taskManagerStore: TaskManagerStore;
    voterListStore: VoterListStore;
    beneficiaryStore: BeneficiaryStore;
    grievanceStore: GrievanceStore;
    voterReachOutStore: VoterReachOutStore;
    electionDayDashboardStore: ElectionDayDashboardStore;
    c3Store: C3Store;
    aiGentoolStore: AiGentoolsStore;
    fieldIntelligenceStore: FieldIntelligenceStore;
    digitalArchiveStore: DigitalArchiveStore;
    influentialLeadersStore: InfluentialLeadersStore;
    projectWorkStoreV2: ProjectWorkStoreV2;
    beneficiaryStoreV2: BeneficiaryStoreV2;
    grievanceStoreV2: GrievanceMgmtStoreV2;
    serviceRequestsStore: ServiceRequestsStore;
    schemeStore: SchemeStore;
    familygrpStore: FamilyGrpStore;

    switch_url: boolean;
    base_url: string | null;
    switch_project: boolean = false;
    appDrawerToggle: boolean = false;
    active_user_profile: boolean = false;
    active_devices_overlay = false;
    logoutModal: boolean = false;

    projectWorksStore: ProjectWorksStore;
    languageChange: boolean = false;
    questionStore: QuestionStore;
    govtconfigStore: GovermentConfigStore;
    influenceLeaderProjectProperty: InfluenceLeaderProjectPropertyStore;
    rteStore: RTEStore;
    notesStore: NotesStore;
    servicePortalStore: ServicePortalStore;
    activeSurveyStore: ActiveSurveyStore;
    cockpitStore: CockpitStore;
    geopolTransformerStore: GeopolTransformerStore;
    mediaStore: PrintMediaStore;
    tarsStore: TarsStore;
    tarsAnalyticsStore: TarsAnalyticsStore;
    qfastStore: QFastStore;

    constructor() {
        makeAutoObservable(this);
        this.appMode = false;
        this.userStore = new UserStore(this);
        this.userStore.checkLogin();

        this.base_url = BASE_URL;

        this.setup_api_interceptors();
        this.projectStore = new ProjectStore(this);
        this.reportStore = new ReportStore(this);
        this.surveyResponseStore = new SurveyResponseStore(this);
        this.voterReachOutStore = new VoterReachOutStore(this);
        this.grievanceStore = new GrievanceStore(this);
        this.appModeInitialize();
        this.flexiStore = new FlexiStore(this);
        this.beneficiaryStore = new BeneficiaryStore(this);
        this.voterListStore = new VoterListStore(this);
        this.taskManagerStore = new TaskManagerStore(this);
        this.projectWorksStore = new ProjectWorksStore(this);
        this.electionDayDashboardStore = new ElectionDayDashboardStore(this);
        this.c3Store = new C3Store(this);
        this.switch_url = false;
        this.aiGentoolStore = new AiGentoolsStore(this);
        this.fieldIntelligenceStore = new FieldIntelligenceStore(this);
        this.digitalArchiveStore = new DigitalArchiveStore(this);
        this.influentialLeadersStore = new InfluentialLeadersStore(this);
        this.projectWorkStoreV2 = new ProjectWorkStoreV2(this);
        this.beneficiaryStoreV2 = new BeneficiaryStoreV2(this);
        this.questionStore = new QuestionStore();
        this.influenceLeaderProjectProperty = new InfluenceLeaderProjectPropertyStore();
        this.grievanceStoreV2 = new GrievanceMgmtStoreV2(this);
        this.serviceRequestsStore = new ServiceRequestsStore(this);
        this.schemeStore = new SchemeStore(this);
        this.familygrpStore = new FamilyGrpStore(this);
        this.rteStore = new RTEStore();
        this.notesStore = new NotesStore();
        this.servicePortalStore = new ServicePortalStore(this);
        this.govtconfigStore = new GovermentConfigStore();
        this.activeSurveyStore = new ActiveSurveyStore(this);
        this.cockpitStore = new CockpitStore(this);
        this.geopolTransformerStore = new GeopolTransformerStore(this);
        this.mediaStore = new PrintMediaStore(this);
        this.tarsStore = new TarsStore(this);
        this.tarsAnalyticsStore = new TarsAnalyticsStore(this);
        this.qfastStore = new QFastStore(this);
        // @ts-ignore
        this.sirStore = new SIRStore(this);
    }

    setup_api_interceptors() {
        if (!this.base_url) {
            this.base_url = "https://platform.forthepeople.ai/api/v1/";
        }

        const apiInstance = create({
            baseURL: this.base_url,
        });

        apiInstance.axiosInstance.interceptors.request.use(
            async (config) => {
                if (!config.baseURL) {
                    config.baseURL = this.base_url;
                }

                let uuid: string; 
                let du: any;
                try {
                    const deviceUUID = new DeviceUUID.DeviceUUID();
                    uuid = deviceUUID.get();
                    du = deviceUUID.parse();
                } catch (error) {
                    uuid = "web-" + Date.now() + "-" + Math.random().toString(36).substr(2, 9);
                    du = {};
                }

                config.headers["X-API-Secret"] = API_HEADER;
                if (this.userStore.isAuthorized) {
                    config.headers["X-Token"] = this.userStore.getToken();
                }

                // Non-blocking IP: use cached value immediately, update cache in background
                const cachedIP = localStorage.getItem("ip");
                if (cachedIP) {
                    config.headers["X-Ip"] = cachedIP;
                }
                // Fire and forget - update cache for next request without blocking
                getIP().catch(() => {});

                config.headers["X-UUID"] = uuid;
                config.headers["X-mode"] = "web";
                config.headers["X-more"] = JSON.stringify(du);
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        apiInstance.axiosInstance.interceptors.response.use(
            (config) => {
                config.headers["Cache-Control"] = "public, max-age=31536000";
                if (config.status === 486) {
                    this.userStore.isAuthorized = false;
                }
                return config;
            },
            (error) => {
                if (error.response && error.response.status === 486) {
                    this.userStore.logout();
                }
                return Promise.reject(error);
            }
        );

        this.api = apiInstance;
    }

    apiRequestHandler = async (url: string, payload: object, errorMessage: string) => {
        try {
            const response = await this.api.post(url, payload);
            if (!response.ok) {
                throw new Error(`${errorMessage}. Status: ${response?.status || "Unknown"}`);
            }
            return response;
        } catch (error) {
            throw new Error(`${error["message"]}`);
        }
    };

    @action
    setIsAuthorised(val: boolean) {
        this.userStore.isAuthorized = val;
        this.userStore.logout();
    }

    @action
    set_switch_url(mode: boolean) {
        this.switch_url = mode;
    }

    appModeInitialize() {
        const appmode_storage = window.localStorage.getItem("__appmode");
        if (appmode_storage && appmode_storage === "true") {
            this.appMode = true;
        }
    }

    @action
    fireAndForgetAction = async (apipath: string) => {
        if (this.userStore.isRoot()) {
            // @ts-ignore
            const response = await this.api.post(apipath, {});
            if (response.status == 200) return true;
        }
        return false;
    };

    @action
    change_base_url(url) {
        this.base_url = url;
        this.api.setBaseURL(url);
        localStorage.setItem("base_url", url);
    }

    @action
    updateHeaders = (_updated_headers) => {
        this.api.headers = _updated_headers;
    };

    getActiveProjectID() {
        return safe_get(toJS(this.projectStore.activeProject), "id", -1);
    }

    @action
    async get_s3_url(bucket: string, path: string) {
        const response = await this.api.post("utils/presignurl", {
            bucket,
            path,
        });
        if (response.status == 200) {
            return response.data["uri"];
        }
        return null;
    }

    @action
    async get_json_resource(json_url_path: string, default_res = {}) {
        try {
            const response = await fetch(json_url_path);
            if (response.status == 200) {
                return await response.json();
            }
            return default_res;
        } catch (e) {
            return default_res;
        }
    }

    @action
    update_switch_project(val) {
        this.switch_project = val;
    }

    @action
    update_mobile_nav(val) {
        this.switch_project = val;
    }

    @action
    update_user_profile(val) {
        this.active_user_profile = val;
    }

    @action
    current_update_active_devices(val) {
        this.active_devices_overlay = val;
    }

    @action
    update_logoutModal(val) {
        this.logoutModal = val;
    }

    @action
    update_language_Change(val) {
        this.languageChange = val;
    }

    @action
    update_appDrawerToggle(val) {
        this.appDrawerToggle = val;
    }

    async get_enquiries(payload:{page:number,page_size:number,query:string}) {
        return this.api.post("rn/getrncontact",payload);
    }

    async init_cloud_secrets() {
        if (!this.api) {
            throw new Error("API instance not initialized");
        }

        // Skip if already initialized - check for existing valid credentials
        const existingKey = localStorage.getItem("S3_ACCESSKEY");
        const existingSecret = localStorage.getItem("S3_SECRETKEY");
        if (existingKey && existingSecret) {
            return; // Already initialized, skip API calls
        }

        try {
            // Parallelize the first two independent API calls
            const [sharedSecretResponse, cloudUploadDownloadCredsResponse] = await Promise.all([
                this.apiRequestHandler("utils/get-shared-secret", {}, "Failed to retrieve shared secret"),
                this.api.post("utils/get-cloud-upload-download-creds"),
            ]);

            const secret = sharedSecretResponse.data?.["secret"];
            const nonce = cloudUploadDownloadCredsResponse.data?.["nonce"];
            const ciphertext = cloudUploadDownloadCredsResponse.data?.["ciphertext"];
            if (!secret || !nonce || !ciphertext) {
                throw new Error("Failed to retrieve cloud secrets");
            } else {
                localStorage.setItem("secret", secret);
                localStorage.setItem("nonce", nonce);
                localStorage.setItem("ciphertext", ciphertext);

                const s3CredentialsResponse = await this.api.post(
                    "utils/get-raw-unsecure-cloud-upload-download-creds",
                    {
                        secret,
                    }
                );

                const S3_ACCESSKEY = await s3CredentialsResponse?.data?.["key"];
                const S3_SECRETKEY = await s3CredentialsResponse?.data?.["secret"];
                if (!S3_ACCESSKEY || !S3_SECRETKEY) {
                    throw new Error("Failed to retrieve S3 credentials");
                } else {
                    localStorage.setItem("S3_ACCESSKEY", S3_ACCESSKEY);
                    localStorage.setItem("S3_SECRETKEY", S3_SECRETKEY);
                }
            }
        } catch (error) {
            throw error;
        }
    }
}
